<template>
    <!-- ---------------------------------- 订阅我们 ---------------------------------- -->
    <div class="subscribe">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <div class="banner">
            <p>订阅蔚诺电子通讯</p>
        </div>
        <!-- ---------------------------------- 表格 ---------------------------------- -->
        <div class="form">
            <!-- 标语 -->
            <div class="slogan">
                <p>
                    想收到Renaud蔚诺有关企业或产品的最新消息及活动资讯，<br />请立即订阅我们的电子通讯。
                </p>
            </div>
            <!-- 表单 -->
            <div class="form_main">
                <p class="form_title">*姓名</p>
                <input maxlength="50" type="text" v-model="name" />
                <p class="form_title">*电邮地址</p>
                <input type="text" v-model="email" @blur="emailRule" />
                <!-- 隐私保护政策 -->
                <div class="privacy">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <p>
                        我已阅读并同意<a
                            href="javascript:;"
                            @click="dialogVisible = true"
                            >隐私保护政策</a
                        >
                    </p>
                    <el-dialog :visible.sync="dialogVisible" width="57%">
                        <!-- :before-close="handleClose" -->
                        <!-- 隐私条款 -->
                        <div class="terms_of">
                            <h2 style="color: #192c54">隐私保护政策</h2>
                            <b>1. 个人资料（隐私）条例</b> <br />
                            <div style="color: #333">
                                <div>
                                    1.1
                                    Renaud蔚诺（「我们」或「本公司」）在收集、保存、使用及传送个人资料时，尊重法例赋予阁下的隐私权利；而本「收集个人资料声明」旨在说明我们处理个人隐私的方法。本公司会确保我们的员工在处理个人资料时依从最严格的保安及保密标准。
                                </div>
                                <div>
                                    1.2
                                    以下将详细说明我们处理个人资料的政策及方法，请仔细参阅及理解。文中所述的政策适用于蔚诺网页（下称「本网页」）的所有使用者。本公司有权按需要随时修订、或另行更改有关的内容。
                                </div>
                                <div>
                                    1.3
                                    倘若本声明的英文本与中文本有任何差异，则以中文本为准。
                                </div>
                                <div>
                                    1.4
                                    「个人资料」指任何阁下在「订阅我们」或「联络我们」的表格上向我们提供的个人资料（包括但不限于阁下的姓名、电邮地址、电话号码、性别）。
                                </div>

                                <br />
                            </div>

                            <b>2. 个人资料的收集及用途</b> <br />
                            <div style="color: #333">
                                <div>
                                    2.1
                                    当阁下填写在「订阅我们」或「联络我们」表格（下称「该表格」）时，我们将收集阁下的个人资料。
                                </div>
                                <div>
                                    2.2
                                    倘若阁下为13岁以下，在提供任何个人资料前，必须先征求家长或监护人同意。
                                </div>
                                <div>
                                    2.3
                                    阁下向我们提供的个人资料将会被Renaud蔚诺用于以下目的（下称「该目的」）：
                                </div>
                                <div>
                                    a.申请、日常运作、延续使用及终止Renaud蔚诺电子通讯的订阅；
                                </div>
                                <div>
                                    b.
                                    向阁下提供Renaud蔚诺的信息、通告及其他信息；
                                </div>
                                <div>c. 处理及跟进服务通话、查询及投诉；</div>
                                <div>d. 核实阁下的身份；及</div>
                                <div>
                                    e.
                                    按照任何对于蔚诺具有约束力的法例要求，而向任何政府机关披露个人资料。
                                </div>
                                <div>
                                    2.4
                                    阁下可自愿决定是否提供表格上没有被标示为必须填写的个人资料。
                                </div>
                                <div>
                                    2.5 使用数据作市场推广（Direct Marketing）
                                    当阁下申请「订阅我们」后，我们会使用阁下的个人资料作市场推广；我们将会使用阁下的姓氏、名字及电邮地址推广。
                                </div>
                            </div>
                            <br />
                            <div><b>3.保留、储存及披露个人资料</b></div>
                            <div style="color: #333">
                                3.1 我们在收集阁下的个人资料时，将会：<br />
                                <div>
                                    a.
                                    向阁下说明我们正在收集你的个人资料以及收集的用途（以本「收集个人资料声明」或独立通知）；
                                </div>
                                <div>
                                    b.
                                    给予阁下反对使用个人资料作特定用途的机会；及
                                </div>
                                <div>
                                    c.
                                    说明我们如何储存及处理个人资料的方法，以及可供阁下查阅、更改及删除已储存个人资料的方法。
                                </div>
                                <div>
                                    3.2
                                    我们将采取所有切实可行的措施，将阁下的个人资料保密，然而我们可以向以下人士转移/分派这些数据用于该目的：
                                </div>
                                <div>
                                    a.
                                    若Renaud蔚诺决定出售其业务的任何相关部份，Renaud蔚诺对阁下个人资料权利的任何实际或建议售让人、承转人或继承人；
                                </div>
                                <div>
                                    b.
                                    向Renaud蔚诺提供行政、电讯、电脑及其他服务的任何代理人、承办商或第三者服务供应商；及
                                </div>
                                <div>
                                    c.
                                    为遵守任何对于Renaud蔚诺具有约束力的法例要求，或为了符合由监管或其他机构发出的任何指引或工作守则，而Renaud蔚诺有义务向其披露数据的人士或机构。
                                </div>
                            </div>
                            <br />
                            <b>4. 保安</b>

                            <div style="color: #333">
                                除以上 &lt;
                                3保留、储存及披露个人资料>所述外，阁下的个人资料不论以任何方式储存，将只限于已获本公司授权的雇员或承办商查阅。凡以电子方式储存的个人资料，将会储存于严密监管的服务器内，并加有密码保护（或使用其他同等形式的保障措施），同时亦只限于获得Renaud蔚诺授权的人员或承办商查阅。获授权的雇员及承办商，只可在按照本收集个人资料声明的规定下处理相关个人资料。
                            </div>
                            <br />
                            <b> 5.查阅及更正个人资料</b>
                            <div style="color: #333">
                                如阁下欲查阅或要求更正本公司持有阁下的个人资料，请电邮至
                                support@renaudchina.com。本公司会在收到阁下的指示后7个工作天内给予回复及更新本公司之纪录。
                            </div>
                            <br />
                            <b>6. 停止使用个人资料作直销用途</b>
                            <div style="color: #333">
                                若阁下不想收取本公司任何推广或宣传数据，不论阁下是否较早前已给予本公司同意（书面或口头）向阁下发放该等数据，阁下可随时电邮至
                                support@renaudchina.com表示要求本公司停止使用阁下的个人资料。本公司会在收到指示后7个工作天内将阁下的个人资料从本公司之名单中删除，并停止使用阁下的个人资料作直接促销用途。
                            </div>
                            <br />
                            <b> 7.数据的保留</b>
                            <div style="color: #333">
                                我们将按收集数据目的所需的时间保留阁下的个人资料。无需保留的个人资料将会销毁。
                            </div>
                            <br />
                            <b>
                                8.此收集个人资料声明可作修订。任何修改将于本网页公布。</b
                            >
                            <br />
                            <!-- 本人确认已阅读、完全明白并同意本人订阅Renaud蔚诺电子通讯受有关私隐政策及使用条款约束。 -->
                        </div>
                    </el-dialog>
                </div>
                <div class="dingyue">
                    <a-button
                        class="form_button"
                        @click="add"
                        :disabled="!checked"
                        >立即订阅</a-button
                    >
                </div>

                <!-- 注释 -->
                <p class="annotation" style="display: none">
                    (您可随时取消订阅，我们将根据私隐政策保障您的个人资料)
                </p>
            </div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Axios from 'axios';
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            name: undefined,
            email: undefined,
            emailR: false,
            checked: false,
            dialogVisible: false,
        };
    },
    methods: {
        emailRule() {
            var that = this;
            if (that.email.toString().length === 0) {
                that.emailR = false;
                return;
            }
            let rule =
                /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
            if (!rule.test(that.email)) {
                this.$message.error('请输入正确的电邮地址！', 1);
            } else {
                that.emailR = true;
            }
        },
        add() {
            var that = this;
            if (!that.email) {
                that.$message.warn('请输入电邮地址', 1);
                return;
            }
            if (that.emailR === false) {
                that.$message.error('请输入正确的电邮地址！', 1);
                return false;
            }
            var data = {
                name: that.name,
                email: that.email,
            };
            var url = `${this.api.ip}/jeecg-boot/h5/h5Controller/subscribeAdd`;
            Axios.post(url, data).then((res) => {
                if (res.data.success === true) {
                    that.$message.success('订阅成功', 1);
                    that.name = undefined;
                    that.email = undefined;
                    that.checked = false;
                } else {
                    that.$message.warning(res.data.message, 1);
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 海报图 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .banner {
        p {
            font-size: 80px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .banner {
        p {
            font-size: 60px;
        }
    }
}
.banner {
    width: 100%;
    height: 541px;
    background: url('../assets/images/subscribe-banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    p {
        color: #112653;
        letter-spacing: 10px;
        position: absolute;
        bottom: 30%;
        right: 15%;
        margin: 0;
    }
}

// ---------------------------- 表格 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 标语
    .slogan {
        p {
            font-size: 52px;
            padding-top: 3.5%;
        }
    }
    // 表单
    .form_main {
        width: 67%;
        // 标头
        .form_title {
            font-size: 46px;
        }
        // 输入框
        input {
            height: 90px;
            font-size: 46px;
            line-height: 90px;
        }
        // 隐私条款
        .privacy {
            p {
                font-size: 50px;
                margin: 0 0 0 50px;
            }
        }
        // 单选框
        .privacy /deep/ .el-checkbox__inner {
            width: 82px;
            height: 82px;
        }
        .privacy /deep/ .el-checkbox__inner::after {
            height: 38px;
            width: 28px;
            top: 9px;
            left: 22px;
        }
    }
    // "立即订阅"按钮
    .dingyue {
        text-align: left;
    }
    .form_button {
        width: 300px;
        height: 95px;
        font-size: 46px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 标语
    .slogan {
        p {
            font-size: 40px;
            font-weight: lighter;
            padding-top: 4.2%;
        }
    }
    // 表单
    .form_main {
        width: 33%;
        // 标头
        .form_title {
            font-size: 26px;
        }
        // 输入框
        input {
            font-size: 22px;
            line-height: 45px;
        }
        // 隐私条款
        .privacy {
            p {
                font-size: 26px;
                margin: 0 0 0 20px;
            }
        }
        // 单选框
        .privacy /deep/ .el-checkbox__inner {
            width: 32px;
            height: 32px;
        }
        .privacy /deep/ .el-checkbox__inner::after {
            height: 18px;
            width: 8px;
            top: 3px;
            left: 11px;
        }
    }
    // "立即订阅"按钮
    .dingyue {
        text-align: center;
    }
    .form_button {
        width: 200px;
        height: 55px;
        font-size: 26px;
    }
}
.form {
    width: 100%;
    background-color: #dfeaf7;
    padding-bottom: 140px;
    // 标语
    .slogan {
        width: 100%;
        height: 305px;
        background: url('../assets/images/subscribe-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        p {
            color: #ffffff;
            letter-spacing: 4px;
            line-height: 1.5;
            margin: 0;
            text-align: center;
        }
    }
    // 表单
    .form_main {
        margin: 0 auto;
        margin-top: 119px;
        // 标头
        .form_title {
            color: #615f5f;
            letter-spacing: 3px;
            margin: 0 0 20px 0;
        }
        // 输入框
        input {
            width: 100%;
            border: 1px solid #ced6e0;
            border-radius: 10px;
            margin-bottom: 50px;
            outline: none;
            padding-left: 10px;
        }
        // 隐私条款
        .privacy {
            display: flex;
            align-items: center;
            p {
                color: #615f5f;
                line-height: 1;
                letter-spacing: 2px;
                a {
                    color: #1d2088;
                    padding-bottom: 5px;
                    border-bottom: 3px solid #1d2088;
                }
            }
            // 条款明细
            .terms_of {
                color: #8c8c8c;
                font-size: 18px;
                div {
                    line-height: 30px;
                }
                b {
                    color: black;
                    display: inline-block;
                    margin-top: 5px;
                    &:first-child {
                        margin-top: 0;
                    }
                }
            }
        }
        .privacy /deep/ .el-checkbox__inner {
            border-radius: 5px;
            font-size: 37px;
        }
        // "立即订阅"按钮
        .dingyue {
            width: 100%;
        }
        .form_button {
            letter-spacing: 2px;
            line-height: 50px;
            text-align: center;
            color: #ffffff;
            background-color: #1d2088;
            border-radius: 10px;
            margin: 50px 0 50px 0;
        }
    }
    // 注释
    .annotation {
        font-size: 23px;
        color: #615f5f;
        text-align: center;
    }
}
/deep/ .el-dialog__body {
    padding: 0 0.104167rem 22px 0.104167rem !important;
    color: #606266;
    font-size: 0.072917rem;
    word-break: break-all;
}
/deep/ .el-dialog__header {
    padding: 0.041667rem 0.104167rem 0.052083rem;
}
</style>



// WEBPACK FOOTER //
// src/view/subscribe.vue